export default __webpack_public_path__ + "static/media/placeholder.cd8d9dd0.jpg";